package com.evoapps.evoshift.data.dto.roster

import com.evoapps.evoshift.data.dto.system.MetadataDto
import kotlinx.serialization.Serializable

@Serializable
data class RosterDto(
    val id: String,
    val workplaceId: String,
    val month: Int,
    val year: Int,
    val status: RosterStatusDto,
    val currentVersion: Int?,
    val metadata: MetadataDto,
    val availabilityRequestId: String? = null
)

@Serializable
enum class RosterStatusDto {
    SKELETON,
    DRAFT,
    PUBLISHED,
    LOCKED,
    ARCHIVED
}